import React, { useEffect, useState } from 'react'
import { axiosGet } from '../util/api'
import { useUser } from '../hooks/useUser'
import { number } from '../util/formatters'
import { Chart, GroupedCharts } from './chart/grouped_charts'
import { Colors, Icon } from '@blueprintjs/core'
import { Card } from './ui/card'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { useOnProfileChange } from '../hooks/useOnProfileChange'

type Data = [number[], number[], number[], number[]]

interface AutomationsProps {
    from: Date
    to: Date
    className?: ClassValue
}

export const Automations = ({ from, to, className }: AutomationsProps) => {
    const [open, setOpen] = useState(true)
    const [loading, setLoading] = useState(false)
    const { profile } = useUser()
    const [smartBids, setSmartBids] = useState<Data | null>(null)
    const [promotions, setPromotions] = useState<Data | null>(null)

    const load = () => {
        if (!profile) {
            setLoading(false)
            return
        }

        setLoading(true)
        axiosGet('automations', { from, to })
            .then((res) => {
                setSmartBids([
                    res.data.smart_bids.current.map((i: any) => new Date(i.date).getTime() / 1000),
                    res.data.smart_bids.current.map((i: any) => parseInt(i.count)),
                    res.data.smart_bids.previous.map((i: any) => new Date(i.date).getTime() / 1000),
                    res.data.smart_bids.previous.map((i: any) => parseInt(i.count)),
                ])
                setPromotions([
                    res.data.promotions.current.map((i: any) => new Date(i.date).getTime() / 1000),
                    res.data.promotions.current.map((i: any) => parseInt(i.count)),
                    res.data.promotions.previous.map((i: any) => new Date(i.date).getTime() / 1000),
                    res.data.promotions.previous.map((i: any) => parseInt(i.count)),
                ])
                setLoading(false)
            })
            .catch((res) => {
                setLoading(false)
                console.log('Res is', res)
            })
    }

    useEffect(() => {
        load()
    }, [from, to])

    useOnProfileChange(() => {
        load()
    })

    const charts: Chart[] = [
        {
            title: 'Smart Bid Changes',
            formatter: number,
            data: smartBids ?? [[], [], [], []],
        },
        {
            title: 'Smart Campaigns Keywords Created',
            formatter: number,
            data: promotions ?? [[], [], [], []],
        },
    ]

    if (!smartBids || !promotions || (smartBids[0].length == 0 && promotions[0].length == 0)) {
        return null
    }

    return (
        <>
            {smartBids && promotions ? (
                <Card
                    className={classNames(
                        'flex flex-col items-start bp4-card-rounded pt-0 px-0',
                        className,
                        {
                            'pb-0': open,
                            'pb-2': !open,
                        },
                    )}
                >
                    <div
                        className={classNames('pl-4 pt-2 text-lg flex items-center cursor-pointer')}
                        onClick={() => setOpen((prev) => !prev)}
                    >
                        <span>Automations</span>
                        <Icon
                            icon={
                                open ? (
                                    <Icon
                                        icon="chevron-down"
                                        color={Colors.GRAY3}
                                        className="ml-2"
                                    />
                                ) : (
                                    <Icon
                                        icon="chevron-down"
                                        color={Colors.GRAY3}
                                        className="ml-2"
                                    />
                                )
                            }
                        />
                    </div>
                    {open && (
                        <GroupedCharts
                            loading={loading}
                            charts={charts}
                            chartClassName="flex-grow mt-2 mx-0"
                        />
                    )}
                </Card>
            ) : (
                <span />
            )}
        </>
    )
}
